import axios from "axios";
import { v4 as uuid } from "uuid";
const { REACT_APP_API_URL } = process.env;
export const LOGIN_URL = `${REACT_APP_API_URL}auth/admin/token`;
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = `${REACT_APP_API_URL}user/forgotPassword`;
export const REFRESH_TOKEN_URL = REACT_APP_API_URL + "auth/refreshToken";
export const ME_URL = `${REACT_APP_API_URL}auth/profile`;

export function login(userName, password) {
  return axios.post(LOGIN_URL, { userName, password });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.put(
    REQUEST_PASSWORD_URL,
    { email },
    {
      headers: {
        "x-requestid": uuid(),
      },
    }
  );
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function getRefreshToken(refreshToken) {
  return axios.post(REFRESH_TOKEN_URL, { refreshToken });
}
